import axios from "../http";
import { handleGetRequestParams } from '../common/js/util'

class Archives {
  // 档案列表
  static getArchivesList(option) {
    let url = `/oa/api/employee/temp/page?`;
    url += handleGetRequestParams(option)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 更新信息
  static postUpdateArchvies(data) {
    const url = `/oa/api/employee/temp/update`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default Archives;